import styled, { css } from 'styled-components';
const mobileAndRailCSS = css `
	display: none;
`;
const desktopCSS = css `
	display: flex;
	background-repeat: no-repeat;
	background-size: cover;
	flex: 1;
	position: relative;
	// Added for the Fanatical Giveaway image to be centered
	background-position: center;

	&:before {
		border-left: 72px solid var(--theme-page-background-color, #fafafa);
		content: '';
		height: 100%;
		position: absolute;
		right: -50px;
		top: 0;
		transform: skewX(-20deg);
		width: 0;
	}

	// Used to crop image with 20 deg angle
	&:after {
		border-left: 72px solid hsla(0, 0%, 100%, 0.25);
		content: '';
		height: 100%;
		position: absolute;
		right: -50px;
		top: 0;
		transform: skewX(-20deg);
		width: 0;
	}
`;
export default styled.div `
	@media (min-width: 320px) {
		${mobileAndRailCSS}
	}

	@media (min-width: 481px) {
		${desktopCSS}
		${(props) => css `
				background-image: url(${props.backgroundImage});
			`}
	}
`;
